module.exports = __webpack_public_path__ + "static/media/slime.ea20fa43.png";